import React from "react";
import { useNavigate } from "react-router-dom";
import ad1 from "../../Images/ad1.png";

export default function MPImageAd() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: "100%",
        aspectRatio: "16/6",
        overflow: "hidden",
        marginTop: 20,
        cursor: "pointer",
      }}
      onClick={() => navigate("/category/master-perfumes")}
    >
      <img
        src={ad1}
        alt="Advertisement"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
          borderRadius: 20,
        }}
      />
    </div>
  );
}
